import img1 from "../../images/abou1.png";
import img2 from "../../images/44.png";

const Water = () => {
  return (
    <div className="container mx-auto mt-20 mb-20 md:px-40 sm:px-40">
      <div>
        <div className="font-bold">ADOUCISSEMENT DE L’EAU</div>
        <div className="mt-2 font-bold text-primary">
          Les bienfaits du calcaire
        </div>
        <p className="mt-2 text-justify">
          Présent naturellement dans l’eau, le calcaire, riche en magnésium,
          minéraux et calcium, est indispensable à l’homme. Mais quand son taux
          est trop élevé – on parle alors d’eau « dure » –, il devient source de
          désagréments pour les consommateurs : usure prématurée des appareils
          domestiques, risque de fuites, irritations des peaux sensibles…
        </p>
      </div>

      <div className="grid mt-10 mb-10 md:grid-cols-2">
        <div className="">
          <div className="">
            <h1 className="font-black text-left text-primary ">
              La décarbonatation collective : un procédé innovant
            </h1>
            <p className="mt-2 text-left">
              AQUAVESC a opté pour une nouvelle solution d’adoucissement de
              l’eau : la décarbonatation collective, qui consiste à enlever le
              calcaire en excédent dès l’étape de production d’eau potable par
              un procédé de décantation. <br /> Ce procédé consiste à augmenter
              le pH de l’eau avec un réactif alcalin (ici, de la soude). Le
              calcaire se forme et décante au fond de l’ouvrage. L’eau claire
              est ensuite récupérée en partie supérieure pour être filtrée.{" "}
              <br /> Pour mettre en place ce traitement, une unité
              complémentaire a été bâtie sur le site de{" "}
              <span className="text-primary"> l’usine de Louveciennes</span>.
              Elle est entrée en service en 2017. <br /> Avant la mise en place
              de ce procédé, la
              <span className="text-primary"> dureté de l’eau</span> distribuée
              était de 35° F.
            </p>
          </div>
        </div>

        {/* <div
          className="h-auto bg-center bg-cover rounded-lg"
          style={{
            backgroundImage: `url(${img1})`,
          }}
        ></div> */}

        <div className="relative">
          <img
            src={img1}
            alt=""
            className="h-auto bg-center bg-cover rounded-lg"
          />
          <h2 className="mt-4 text-xs text-black text-start">
            L'unité de décarbonatation de l'usine de Louveciennes, mise en service 2017
          </h2>
        </div>
      </div>

      <div className="grid grid-rows-2 gap-5 md:grid-cols-2">
        <div
          className="h-auto bg-center bg-cover rounded-lg"
          style={{
            backgroundImage: `url(${img2})`,
            backgroundSize: "cover",
          }}
        ></div>
        <div className="">
          <div className="">
            <p className="text-left">
              La décarbonatation collective a permis de l’adoucir
              considérablement, puisqu’elle est aujourd’hui à 20° F. Ce procédé
              a permis aux consommateurs alimentés par AQUAVESC d’économiser aux
              alentours de 200 euros par an et par foyer.
            </p>
            <h1 className="mt-10 font-black text-left text-primary ">
              Un circuit vertueux
            </h1>
            <p className="mt-2 text-left">
              Les 4 000 tonnes de calcaire extraites chaque année sont
              déshydratées puis utilisées comme boue d’épandage par les
              agriculteurs d’une cinquantaine de communes de la région. Cet
              apport calcique naturel neutralise l’acidité de certains sols,
              néfastes pour les cultures.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Water;
